import { render } from "./AdminTerminDetail.vue?vue&type=template&id=0b2f7e4f&scoped=true"
import script from "./AdminTerminDetail.vue?vue&type=script&lang=js"
export * from "./AdminTerminDetail.vue?vue&type=script&lang=js"

import "./AdminTerminDetail.vue?vue&type=style&index=0&id=0b2f7e4f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2f7e4f"]])

export default __exports__